import uniqueId from 'lodash/uniqueId'

export function generateSelectorReference () {
  return uniqueId('selector-')
}
